import { render, staticRenderFns } from "./panel_pet.vue?vue&type=template&id=3e6f3cf7&scoped=true&"
import script from "./panel_pet.vue?vue&type=script&lang=js&"
export * from "./panel_pet.vue?vue&type=script&lang=js&"
import style0 from "./panel_pet.vue?vue&type=style&index=0&id=3e6f3cf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6f3cf7",
  null
  
)

export default component.exports